module.exports = __webpack_public_path__ + "media/images/folder_closed-4c28eb1b3c7b1009630de3441a947eff.png";